'use strict';
(function () {
    angular.module('pulse')
        .controller('NotFoundCtrl', NotFoundCtrl);

    NotFoundCtrl.$inject = ['$log', '$scope', 'HelperSvc', '$window', 'AuthenticationService', '$rootScope'];

    function NotFoundCtrl($log, $scope, HelperSvc, $window, AuthenticationService, $rootScope) {

        $log.log('NotFoundCtrl Init');

        if ($rootScope.modalInstance && typeof $rootScope.modalInstance.close === 'function') {
            $rootScope.modalInstance.close();
        }

        // if user is not logged in then the user will be logged out from the interceptor because of 401
        AuthenticationService.findMe();

        // hide loading spinner
        $('#main_pulse_loader').hide();

        $scope.handleRedirection = function () {
            $log.log('redirect to the login page');

            const isUseHasAppAccess = HelperSvc.checkAppAccess();

            if (!isUseHasAppAccess) {
                // check user is logged in or not by checking the root scope
                $window.location = $window.location.protocol + '//' + $window.location.hostname + '/dashboard';
            } else {
                $window.location = $window.location.protocol + '//' + $window.location.hostname + $window.location.pathname;
            }

        }

    }
})();